module.exports = __webpack_public_path__ + "img/10.44ec0fc2.jpg";